import { Alert, Button, Stack, Typography, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import get from "../../../api/auth/organization/show";
import PageLoading from "../../../components/layout/PageLoading";
import getOauthRedirectUrl from "../../../api/auth/stripe/getOauthRedirectUrl";
import update from "../../../api/auth/organization/update";

export default function Stripe() {
  const [ organization, setOrganization ] = useState();

  const initiateOauth = () => {
    getOauthRedirectUrl((response) => {
      window.location = response.url;
    });
  };

  useEffect(() => {
    get(1, (response) => {
      setOrganization(response);
    });
  }, []);

  const handleUpdate = (data) => {
    update(organization.id, data, (response) => {
      setOrganization(response);
    });
  };

  if(!organization) return <PageLoading />;

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">
          Stripe
        </Typography>
        <Typography variant="body1">
          Configure your stripe integration here.
        </Typography>
      </Stack>
      {organization.stripe_account_id &&
        <Stack direction="row">
          <Alert severity="success">
            Your stripe account is connected!
          </Alert>
        </Stack>
      }
      {!organization.stripe_account_id && <Stack>
        <Stack direction="row">
          <Button variant="contained" onClick={initiateOauth}>
            Connect with Stripe
          </Button>
        </Stack>
      </Stack>}
      <Stack direction="row" mb={2}>
        <Switch
          checked={organization.stripe_service_fee_to_customer}
          onChange={(event) => handleUpdate({ stripe_service_fee_to_customer: event.target.checked })}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        <Typography sx={{ my: "auto" }} variant="body1" fontWeight="700">
          Apply Stripe service fee to customer orders
        </Typography>
      </Stack>
    </Stack>
  );
}